<template>
  <div class="page">
    <section class="section has-background-yellow-light">
      <div class="container">
        <h1 class="title is-h1 is-page-title">
          {{ name }}
        </h1>
        <div class="columns">
          <div class="column is-one-quarter">
            <menu-sidebar v-if="mainMenu" :menu="mainMenu" />
          </div>
          <div class="column">
            <views-article-taxonomy-list :tids="[tid]" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const initData = await useInitData()
const mainMenu = initData.value.mainMenuLinks

defineProps<{
  tid?: number
  name?: string
  description?: string
}>()
</script>
